import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  showErrorToastMessage,
  showSuccessToastMessage,
} from "../../../component/Toasts/Toasts";
import * as actions from "../../../Redux/Actions/index";
import moment from "moment";
import { Dropdown, InputGroup, Spinner, Button as BSButton } from "react-bootstrap";
import Button from "../../../component/Buttons/Button";
import "./style.scss"
import SendEmail from "./SendEmail";
import Select from "react-select";
import {
  Strings,
  addEmployeeValidations,
  addEmployeeLabels,
} from "../../../constant/Strings";
import {
  employeeDesignationValidtion,
  employeeMobileNumberValidtion,
  employeeEmailIdValidation,
  employeeEmployeeIdValidtion,
  employeeLastNameValidtion,
  employeeCandidateNameValidtion,
  containsInvalidChars,
} from "../../../constant/Validations";
import { timeDateFormat } from "../../../component/FormatDate";
import ModalComponents from "../../../component/ModalComponent/ModalComponent";
import { BsCheckLg, BsXLg, BsGear } from "react-icons/bs";
import DepartmentManagerModal from "../../../component/ModalComponent/DepartmentManagerModal";
import ClientManagerModal from "../../../component/ModalComponent/ClientManagerModal";

const EditEmployee = (props: any) => {
  const userLogin: any = localStorage.getItem("login");
  const role = localStorage.getItem("role");
  const employeeHrManager = role?.includes("employee-db-hrmanager");
  const employeeDbChecker = role?.includes("employee-db-checker");
  const loginId = JSON.parse(userLogin).id;
  const {
    id,
    title,
    candidateName,
    middleName,
    lastname,
    email,
    mobileNumber,
    designation,
    designationRef,
    dateOfJoining,
    dateOfBirth,
    personalMail,
    employeeId,
    recordStatus,
    hideEditModal,
    eId,
    reportingManagerName,
    statusData,
    lastWorkingDate,
    managerRef,
    reason,
    reasonForResignation,
    apiCallCompleted,
    resentDate,
    clientName,
    department,
    businessUnit,
    subDepartment,
    financeCode,
    projectClassification,
    projectType,
    location,
    modeofWork,
    buHead,
    departmentRef,
    subDepartmentRef,
    clientRef,
    hrbpRef,
    buHeadRef,
    welcomeEmailSent,
    onEmployeeUpdated,
    onsurity,
    gender,
  } = props;
  const [employeeData, setEmployeeData] = useState({
    id: id,
    title: title,
    candidateName: candidateName,
    middleName: middleName,
    lastname: lastname,
    emailId: email,
    mobileNumber: mobileNumber,
    designation: designation,
    designationRef: designationRef || "",
    dateOfJoining: dateOfJoining,
    dateOfBirth: dateOfBirth,
    gender: gender || "",
    personalMail: personalMail,
    employeeId: employeeId,
    eId: eId,
    updatedBy: loginId,
    managerRef: managerRef,
    reportingManagerName: reportingManagerName,
    clientName: clientName,
    department: department,
    businessUnit: businessUnit,
    subDepartment: subDepartment,
    financeCode: financeCode,
    projectClassification: projectClassification,
    projectType: projectType,
    location: location,
    modeofWork: modeofWork,
    buHead: buHead,
    departmentRef: departmentRef || "",
    subDepartmentRef: subDepartmentRef || "",
    clientRef: clientRef || "",
    buHeadRef: buHeadRef || "",
    hrbpRef: hrbpRef || "",
  });
  const { clientNameLabel } = addEmployeeLabels;
  const [errors, setErrors] = useState({
    candidateName: "",
    middleName: "",
    lastname: "",
    emailId: "",
    mobileNumber: "",
    employeeId: "",
    designation: "",
    clientName: "",
    department: "",
    businessUnit: "",
    subDepartment: "",
    financeCode: "",
    projectClassification: "",
    projectType: "",
    location: "",
    modeofWork: "",
    buHead: "",
  });
  const [hasFetchedSubDepts, setHasFetchedSubDepts] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [nextScreen, setnextScreen] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showInsuranceConfirmModal, setShowInsuranceConfirmModal] = useState(false);
  const [isApproving, setIsApproving] = useState(false);
  const [justReassigned, setJustReassigned] = useState(false);
  const {
    designationValid,
    mobileNumberValid,
    emailIdValid,
    employeeIdValid,
    lastnameValid,
    candidateNameValid,
  } = addEmployeeValidations;
  const {
    editSuccess,
    cancel,
    submit,
    skillmineMailid,
    first_name,
    middle_name,
    last_name,
    date_of_birth,
    personal_email_iD,
    e_code,
    date_of_joining,
    reporting_manager_name,
    official_email,
    mobile_number,
    employee_title,
    employee_designation,
    record_status,
    last_working_date,
    status,
    Reason,
    ReasonForResignation,
    active_label,
    inactive_label,
    new_label,
    absconded_label,
    resigned_label,
    departmentLabel,
    invalidCharsError
  } = Strings;
  const [employeeInfo, setEmployeeInfo] = useState([]);
  const [statusDetails, setStatusDetails] = useState({
    status: statusData,
    recordStatus: recordStatus,
    lastWorkingDate: lastWorkingDate,
    eId: eId,
    updatedBy: loginId,
    reason: reason,
    reasonForResignation: reasonForResignation,
    resentDate: resentDate,
  });

  const dispatch = useDispatch();
  const isHrAdmin = (localStorage.getItem("role") || "").includes("hr-admin");

  useEffect(() => {
    if (
      employeeData.candidateName &&
      employeeData.lastname &&
      employeeData.dateOfBirth &&
      employeeData.employeeId &&
      employeeData.emailId &&
      employeeData.mobileNumber &&
      employeeData.designation &&
      employeeData.dateOfJoining &&
      employeeData.title &&
      employeeData.managerRef &&
      employeeData.reportingManagerName &&
      employeeData.businessUnit &&
      employeeData.department &&
      employeeData.subDepartment &&
      employeeData.financeCode &&
      employeeData.projectClassification &&
      employeeData.projectType &&
      employeeData.location &&
      employeeData.modeofWork &&
      employeeData.buHead &&
      employeeData.clientName &&
      ((statusDetails.status === "Active" &&
        statusDetails.status &&
        statusDetails.recordStatus) ||
        (statusDetails.status === "Inactive" &&
          statusDetails.lastWorkingDate &&
          statusDetails.lastWorkingDate.length > 0) ||
        (statusDetails.status === "New" && statusDetails.recordStatus))
    ) {
      setBtnDisable(true);
    } else {
      setBtnDisable(false);
    }
  }, [employeeData, statusDetails]);
  let valid: boolean = true;
  const validate = () => {
    if (!employeeData.designation?.trim()) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        designation: "Designation is required",
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, designation: "" }));
    }
    if (employeeMobileNumberValidtion(employeeData.mobileNumber) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        mobileNumber: mobileNumberValid,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, mobileNumber: "" }));
    }
    if (
      employeeEmailIdValidation(employeeData.emailId) &&
      employeeData.emailId.includes(skillmineMailid)
    ) {
      setErrors((errorObj) => ({ ...errorObj, emailId: "" }));
    } else {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        emailId: emailIdValid,
      }));
      setBtnDisable(false);
    }

    if (
      employeeData.employeeId.length < 5 ||
      employeeData.employeeId.length > 9 ||
      employeeEmployeeIdValidtion(employeeData.employeeId) == false
    ) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        employeeId: employeeIdValid,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, employeeId: "" }));
    }
    if (containsInvalidChars(employeeData.lastname)) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        lastname: invalidCharsError,
      }));
      setBtnDisable(false);
    } else if (employeeLastNameValidtion(employeeData.lastname) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        lastname: lastnameValid,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, lastname: "" }));
    }
    if (employeeData.middleName) {
      if (containsInvalidChars(employeeData.middleName)) {
        valid = false;
        setErrors((errorObj) => ({
          ...errorObj,
          middleName: invalidCharsError,
        }));
        setBtnDisable(false);
      } else if (employeeCandidateNameValidtion(employeeData.middleName) == false) {
        valid = false;
        setErrors((errorObj) => ({
          ...errorObj,
          middleName: candidateNameValid,
        }));
        setBtnDisable(false);
      } else {
        setErrors((errorObj) => ({ ...errorObj, middleName: "" }));
      }
    }
    if (containsInvalidChars(employeeData.candidateName)) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        candidateName: invalidCharsError,
      }));
      setBtnDisable(false);
    } else if (employeeCandidateNameValidtion(employeeData.candidateName) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        candidateName: candidateNameValid,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, candidateName: "" }));
    }
    if (containsInvalidChars(employeeData.businessUnit)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, businessUnit: invalidCharsError }));
    } else if (!employeeData.businessUnit?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, businessUnit: "Business Unit is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, businessUnit: "" }));
    }
    if (containsInvalidChars(employeeData.department)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, department: invalidCharsError }));
    } else if (!employeeData.department?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, department: "Department is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, department: "" }));
    }
    if (containsInvalidChars(employeeData.subDepartment)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, subDepartment: invalidCharsError }));
    } else if (!employeeData.subDepartment?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, subDepartment: "Sub Department is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, subDepartment: "" }));
    }
    if (containsInvalidChars(employeeData.financeCode)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, financeCode: invalidCharsError }));
    } else if (!employeeData.financeCode?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, financeCode: "Finance Code is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, financeCode: "" }));
    }
    if (containsInvalidChars(employeeData.projectClassification)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, projectClassification: invalidCharsError }));
    } else if (!employeeData.projectClassification?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, projectClassification: "Project Classification is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, projectClassification: "" }));
    }
    if (containsInvalidChars(employeeData.projectType)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, projectType: invalidCharsError }));
    } else if (!employeeData.projectType?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, projectType: "Project Type is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, projectType: "" }));
    }
    if (containsInvalidChars(employeeData.location)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, location: invalidCharsError }));
    } else if (!employeeData.location?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, location: "Location is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, location: "" }));
    }
    if (containsInvalidChars(employeeData.modeofWork)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, modeofWork: invalidCharsError }));
    } else if (!employeeData.modeofWork?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, modeofWork: "Mode of Work is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, modeofWork: "" }));
    }
    if (containsInvalidChars(employeeData.buHead)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, buHead: invalidCharsError }));
    } else if (!employeeData.buHead?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, buHead: "BU Head is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, buHead: "" }));
    }
    //  if (!employeeData.buHead || !employeeData.buHead.trim()) {
    //   valid = false;
    //   setErrors((errorObj) => ({ ...errorObj, buHead: "BU Head is required" }));
    // } else {
    //   setErrors((errorObj) => ({ ...errorObj, buHead: "" }));
    // }
    if (containsInvalidChars(employeeData.clientName)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, clientName: invalidCharsError }));
    } else if (!employeeData.clientName?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, clientName: "Client Name is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, clientName: "" }));
    }
  };

  // const handleDispatchSubmit = () => {
  //   dispatch(actions.updateSelectedIdAction(id));
  //   apiCallCompleted(false);
  //   dispatch(
  //     actions.editEmployeeDataAction(statusDetails, (statusRes: any) => {
  //       if (statusRes?.error?.error_description) {
  //         showErrorToastMessage(statusRes.error.error_description);
  //         apiCallCompleted(true);
  //          return;
  //       } 
  //       if (statusRes?.code === 200) {
  //         // This sends the simple employeeData, without the 'action' flag
  //         dispatch(
  //           actions.editEmployeeDataAction(employeeData, (mainRes: any) => {
  //             if (mainRes?.error?.error_description) {
  //               showErrorToastMessage(mainRes.error.error_description);
  //               apiCallCompleted(true);
  //             } else {
  //               if (mainRes?.code === 200) {
  //                 showSuccessToastMessage(editSuccess); 
  //                 apiCallCompleted(true);
  //                 hideEditModal(); 
  //               }
  //             }
  //           })
  //         );
  //       }
  //     })
  //   );
  //   dispatch(actions.editEmployeeDataAction(statusDetails, (res: any) => {}));
  //   hideEditModal();
  // };

  // Whether this employee's Insurance tab has enough filled in for auto-enrollment to actually
  // fire (mirrors isOnsurityDataComplete on the backend) — used to decide whether the insurance
  // confirmation dialog should appear when status is being moved to Active.
  const isInsuranceComplete = !!(
    onsurity?.nominee?.name &&
    (onsurity?.healthPlan?.planName || onsurity?.lifePlan?.planName)
  );
  const isEnteringActiveStatus = statusDetails.status === "Active" && statusData !== "Active";

  const handleSimpleSubmit = () => {
    validate();
    if (!valid) return;
    if (isEnteringActiveStatus && isInsuranceComplete && !showInsuranceConfirmModal) {
      setShowInsuranceConfirmModal(true);
      return;
    }
    setShowInsuranceConfirmModal(false);
    performSimpleSubmit();
  };

  const performSimpleSubmit = () => {
    setIsApproving(true);

    const simpleStatusPayload = { ...statusDetails, action: 'update' };

    const simpleEmployeePayload = { ...employeeData };
     // console.log("PAYLOAD:", simpleEmployeePayload)
      dispatch(actions.updateSelectedIdAction(id));
      apiCallCompleted(false);

      dispatch(
        actions.editEmployeeDataAction(simpleStatusPayload, (statusRes: any) => {
          if (statusRes?.error?.error_description) {
            showErrorToastMessage(statusRes.error.error_description);
            apiCallCompleted(true);
            setIsApproving(false);
            return;
          }
          if (statusRes?.code === 200) {
            dispatch(
              actions.editEmployeeDataAction(simpleEmployeePayload, (mainRes: any) => {
                if (mainRes?.error?.error_description) {
                  showErrorToastMessage(mainRes.error.error_description);
                  apiCallCompleted(true);
                  setIsApproving(false);
                } else if (mainRes?.code === 200) {
                  if (isEnteringActiveStatus && isInsuranceComplete) {
                    showSuccessToastMessage("Employee updated. Insurance enrollment has been triggered in the background — check the Insurance tab shortly for status.");
                  } else {
                    showSuccessToastMessage(editSuccess);
                  }
                  apiCallCompleted(true);
                  hideEditModal();
                  if (welcomeEmailSent === false && onEmployeeUpdated) {
                    onEmployeeUpdated({ employeeId: id, personalMail: employeeData.personalMail ?? personalMail, hrbpRef: employeeData.hrbpRef ?? hrbpRef, managerRef: employeeData.managerRef ?? managerRef });
                  }
                }
              })
            );
          }
        })
      );
  };

  const handleConfirmAndProceed = () => {
    validate();
    if (valid) {
      setIsApproving(true);
      console.log("--- APPROVE BUTTON CLICKED ---");

      const statusPayload = { ...statusDetails, recordStatus: 'Approved', action: 'approve' };
      const approvalPayload = { ...employeeData, action: 'approve' };

      dispatch(actions.updateSelectedIdAction(id));
      apiCallCompleted(false);

      dispatch(
        actions.editEmployeeDataAction(statusPayload, (statusRes: any) => {
          if (statusRes?.error?.error_description) {
            showErrorToastMessage(statusRes.error.error_description);
            apiCallCompleted(true);
            setIsApproving(false);
            return;
          }
          if (statusRes?.code === 200) {
            dispatch(
              actions.editEmployeeDataAction(approvalPayload, (mainRes: any) => {
                if (mainRes?.error?.error_description) {
                  showErrorToastMessage(mainRes.error.error_description);
                  apiCallCompleted(true);
                } else if (mainRes?.code === 200) {
                  showSuccessToastMessage("Employee Approved! Proceeding to send email.");
                  apiCallCompleted(true);
                  hideEditModal();
                }
              })
            );
          }
        })
      );
      // hideEditModal()
    }
  };


  const employeeManagerData = useSelector(
    (state: any) => state.employeeReducer.getEmployeeData
  );
  useEffect(() => {
    if (employeeManagerData && employeeManagerData.data) {
      setEmployeeInfo(employeeManagerData.data);
    }
  }, [employeeManagerData, employeeInfo]);
  const managerOptions: any = employeeInfo.map((ele: any) => ({
    value: ele._id,
    label: ele.middleName
      ? ele.candidateName +
      " " +
      ele.middleName +
      " " +
      ele.lastname +
      "-" +
      ele.employeeId
      : ele.candidateName + " " + ele.lastname + "-" + ele.employeeId,
  }));
  const handleReportingManager = (selected: any) => {
    setEmployeeData({
      ...employeeData,
      managerRef: selected.value,
      reportingManagerName: selected.label,
    });
  };
  const handleBuHeadChange = (selected: any) => {
    setEmployeeData({
      ...employeeData,
      buHead: selected ? selected.label : "", 
      buHeadRef: selected ? selected.value : "" 
    });
     if (selected) setErrors(prev => ({ ...prev, buHead: "" }));
  };

  const handleHrbpChange = (selected: any) => {
    setEmployeeData({
      ...employeeData,
      hrbpRef: selected ? selected.value : ""
    });
  };

  const [setDropdown, setShowDropdown] = useState(false);
  // --- DEPARTMENT STATES ---
  const [deptOptions, setDeptOptions] = useState<any[]>([]);
  const [isAddingDept, setIsAddingDept] = useState(false);
  const [newDeptName, setNewDeptName] = useState("");
  const [isSubmittingDept, setIsSubmittingDept] = useState(false);
  const [showDeptManager, setShowDeptManager] = useState(false);

  // --- DESIGNATION STATES ---
  const [designationOptions, setDesignationOptions] = useState<any[]>([]);
  const [isAddingDesignation, setIsAddingDesignation] = useState(false);
  const [newDesignationName, setNewDesignationName] = useState("");
  const [isSubmittingDesignation, setIsSubmittingDesignation] = useState(false);

  // --- SUB-DEPARTMENT STATES ---
  const [subDeptOptions, setSubDeptOptions] = useState<any[]>([]);
  const [isAddingSubDept, setIsAddingSubDept] = useState(false);
  const [newSubDeptName, setNewSubDeptName] = useState("");
  const [isSubmittingSubDept, setIsSubmittingSubDept] = useState(false);
  const [showSubDeptManager, setShowSubDeptManager] = useState(false);

  // --- CLIENT STATES ---
  const [clientOptions, setClientOptions] = useState<any[]>([]);
  const [isAddingClient, setIsAddingClient] = useState(false);
  const [newClientName, setNewClientName] = useState("");
  const [isSubmittingClient, setIsSubmittingClient] = useState(false);
  const [showClientManager, setShowClientManager] = useState(false);

  // Load Initial Data
  useEffect(() => {
    dispatch(actions.getAllDepartmentsAction((res: any) => { if (res?.data) setDeptOptions(res.data); }));
    dispatch(actions.getAllDesignationsAction((res: any) => { if (res?.data) setDesignationOptions(res.data); }));
    dispatch(actions.getClientNameAction());
  }, [dispatch]);

  // Back-fill designationRef from the loaded list if only the title is known
  useEffect(() => {
    if (designationOptions.length > 0 && employeeData.designation && !employeeData.designationRef) {
      const match = designationOptions.find((d: any) => d.title === employeeData.designation);
      if (match) setEmployeeData((prev: any) => ({ ...prev, designationRef: match._id }));
    }
  }, [designationOptions, employeeData.designation, employeeData.designationRef]);

  const clientDataRedux = useSelector((state: any) => state.employeeReducer.getClientNameDetails);
  useEffect(() => { if (clientDataRedux?.data) setClientOptions(clientDataRedux.data); }, [clientDataRedux]);

  // Load Sub-Depts when Dept changes
  useEffect(() => {
    if (deptOptions.length === 0) return;

    const selectedDept = deptOptions.find(d => d.departmentName === employeeData.department);

    if (selectedDept) {
      setHasFetchedSubDepts(false);
      dispatch(actions.getSubDepartmentsByParentAction(selectedDept._id, (res: any) => {
        if (res?.data) setSubDeptOptions(res.data);
        setHasFetchedSubDepts(true);
      }));
    } else {
      setSubDeptOptions([]);
      setHasFetchedSubDepts(true);
    }
  }, [employeeData.department, deptOptions, dispatch]);

  useEffect(() => {
    if (employeeData.department && deptOptions.length > 0) {
      if (!deptOptions.some(d => d.departmentName === employeeData.department)) {
        setEmployeeData(prev => ({ ...prev, department: "", subDepartment: "" }));
      }
    }
  }, [deptOptions, employeeData.department]);

  useEffect(() => {
    if (employeeData.subDepartment && hasFetchedSubDepts) {

      const exists = subDeptOptions.some(d => d.subDepartmentName === employeeData.subDepartment);
      if (!exists && !justReassigned) {
        setEmployeeData(prev => ({
          ...prev,
          subDepartment: "",
          subDepartmentRef: ""
        }));
      } else {
        // console.log(">>> KEEPING FIELD (Valid or Just Reassigned)");
        // Reset the shield so future checks work normally
        if (justReassigned) setJustReassigned(false);
      }
    }
  }, [subDeptOptions, employeeData.subDepartment, hasFetchedSubDepts, justReassigned]);

  useEffect(() => {
    if (employeeData.clientName && clientOptions.length > 0) {
      const exists = clientOptions.some(c => c.clientName === employeeData.clientName);
      if (!exists && !justReassigned) {
        setEmployeeData(prev => ({ ...prev, clientName: "", clientRef: "" }));
      } else {
        // Reset shield if valid
        if (justReassigned) setJustReassigned(false);
      }
    }
  }, [clientOptions, employeeData.clientName, justReassigned]);
  useEffect(() => {
    if (employeeData.clientName && !employeeData.clientRef && clientOptions.length > 0) {
      const match = clientOptions.find(c => c.clientName === employeeData.clientName);
      if (match) {
        //console.log("Auto-fixing Client Ref:", match._id);
        setEmployeeData(prev => ({ ...prev, clientRef: match._id }));
      }
    }
  }, [clientOptions, employeeData.clientName, employeeData.clientRef]);
   useEffect(() => {
    if (managerOptions.length > 0) {
      setEmployeeData(prev => {
        let updates: any = {};
        let hasUpdates = false;

    
        if (prev.buHead && !prev.buHeadRef) {
          const match = managerOptions.find((opt: any) => opt.label === prev.buHead);
          if (match) {
            console.log("Auto-fixing BU Head Ref:", match.value);
            updates.buHeadRef = match.value;
            hasUpdates = true;
          }
        }
        return hasUpdates ? { ...prev, ...updates } : prev;
      });
    }
  }, [managerOptions, employeeData.buHead, employeeData.buHeadRef]);
  const handleAddNewClient = () => {
    if (!newClientName.trim() || containsInvalidChars(newClientName)) return;
    setIsSubmittingClient(true);
    dispatch(actions.addClientNameAction({ clientName: newClientName }, (res: any) => {
      setIsSubmittingClient(false);
      if (res?.data || res?.code === 200) {
        const addedName = res?.data?.clientName || newClientName;
        const addedId = res?.data?._id || "";
        setClientOptions(prev => [...prev, res.data || { clientName: newClientName }]);
        setEmployeeData(prev => ({ ...prev, clientName: addedName, clientRef: addedId }));
        setIsAddingClient(false);
        setNewClientName("");
        dispatch(actions.getClientNameAction());
      }
    }) as any);
  };

  const handleAddNewDept = () => {
    if (!newDeptName.trim() || containsInvalidChars(newDeptName)) return;
    setIsSubmittingDept(true);
    dispatch(actions.createDepartmentAction({ departmentName: newDeptName }, (res: any) => {
      setIsSubmittingDept(false);
      if (res?.data) {
        setDeptOptions([...deptOptions, res.data]);
        setEmployeeData(prev => ({ ...prev, department: res.data.departmentName, departmentRef: res.data._id, subDepartment: "", subDepartmentRef: "" }));
        setIsAddingDept(false);
        setNewDeptName("");
      }
      else {
        const errorMsg = res?.error?.response?.data?.error?.error_description || "Failed to add department";
        showErrorToastMessage(errorMsg);
      }
    }));
  };

  const handleAddNewDesignation = () => {
    if (!newDesignationName.trim() || containsInvalidChars(newDesignationName)) return;
    setIsSubmittingDesignation(true);
    dispatch(actions.createDesignationAction({ title: newDesignationName }, (res: any) => {
      setIsSubmittingDesignation(false);
      if (res?.data) {
        setDesignationOptions([...designationOptions, res.data]);
        setEmployeeData(prev => ({ ...prev, designation: res.data.title, designationRef: res.data._id }));
        setIsAddingDesignation(false);
        setNewDesignationName("");
      } else {
        const errorMsg = res?.error?.response?.data?.error?.error_description || "Failed to add designation";
        showErrorToastMessage(errorMsg);
      }
    }));
  };

  const handleAddNewSubDept = () => {
    if (!newSubDeptName.trim() || containsInvalidChars(newSubDeptName)) return;
    const parent = deptOptions.find(d => d.departmentName === employeeData.department);
    if (!parent) return;
    setIsSubmittingSubDept(true);
    dispatch(actions.createSubDepartmentAction({ subDepartmentName: newSubDeptName, departmentRef: parent._id }, (res: any) => {
      setIsSubmittingSubDept(false);
      if (res?.data) {
        setSubDeptOptions([...subDeptOptions, res.data]);
        setEmployeeData(prev => ({ ...prev, subDepartment: res.data.subDepartmentName, subDepartmentRef: res.data._id }));
        setIsAddingSubDept(false);
        setNewSubDeptName("");
      } else {
        const errorMsg = res?.error?.response?.data?.error?.error_description || "Failed to add sub-department";
        showErrorToastMessage(errorMsg);
      }
    }));
  };

  const disable = statusData == "Active" || statusData == "Inactive";

  return (
    <>
      {showConfirmModal ? (
        <ModalComponents
          show={true}
          onHide={() => setShowConfirmModal(false)}
          title="Confirm Action"
          modalBody={
            <div className="p-3">
              <p>Are you sure you want to approve this employee and proceed to send the email?</p>
              <div className="d-flex justify-content-end mt-4">
                <button
                  className="btn btn-secondary me-2"
                  onClick={() => setShowConfirmModal(false)}
                >
                  Cancel
                </button>
                <Button
                  title={isApproving ? "Approving..." : "Yes, Approve"}
                  onClick={handleConfirmAndProceed}
                  className="add-employee-btn"
                  disabled={isApproving}
                />
              </div>
            </div>
          }
        />
      ) : showInsuranceConfirmModal ? (
        <ModalComponents
          show={true}
          onHide={() => setShowInsuranceConfirmModal(false)}
          title="Confirm Insurance Enrollment"
          modalBody={
            <div className="p-3">
              <p>
                Setting this employee to Active will automatically enroll them with Onsurity
                using the details below. Please review before proceeding.
              </p>
              <div className="mt-3">
                <strong>Nominee</strong>
                <p className="mb-1">
                  {onsurity?.nominee?.name} ({onsurity?.nominee?.relation})
                </p>
              </div>
              {onsurity?.dependents?.length > 0 && (
                <div className="mt-3">
                  <strong>Dependents</strong>
                  {onsurity.dependents.map((d: any, i: number) => (
                    <p className="mb-1" key={i}>
                      {d.name} ({d.relation}{d.gender ? `, ${d.gender}` : ""})
                    </p>
                  ))}
                </div>
              )}
              {onsurity?.healthPlan?.planName && (
                <div className="mt-3">
                  <strong>Health Plan</strong>
                  <p className="mb-1">
                    {onsurity.healthPlan.planName} ({onsurity.healthPlan.policyType})
                  </p>
                </div>
              )}
              {onsurity?.lifePlan?.planName && (
                <div className="mt-3">
                  <strong>Life Plan</strong>
                  <p className="mb-1">
                    {onsurity.lifePlan.planName} ({onsurity.lifePlan.policyType})
                  </p>
                </div>
              )}
              <div className="d-flex justify-content-end mt-4">
                <button
                  className="btn btn-secondary me-2"
                  onClick={() => setShowInsuranceConfirmModal(false)}
                >
                  Cancel
                </button>
                <Button
                  title={isApproving ? "Submitting..." : "Confirm & Submit"}
                  onClick={performSimpleSubmit}
                  className="add-employee-btn"
                  disabled={isApproving}
                />
              </div>
            </div>
          }
        />
      ) : nextScreen ? (
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <label className="form-label">
                {employee_title}
                <span className="required">*</span>
              </label>
              <Dropdown
                onMouseLeave={() => setShowDropdown(false)}
                onSelect={(eventKey: any) =>
                  setEmployeeData({
                    ...employeeData,
                    title: eventKey,
                  })
                }
              >
                <Dropdown.Toggle variant="light" className="form-control">
                  {employeeData.title}
                </Dropdown.Toggle>
                <Dropdown.Menu show={setDropdown}>
                  <Dropdown.Item eventKey="Dr.">Dr.</Dropdown.Item>
                  <Dropdown.Item eventKey="Miss">Miss</Dropdown.Item>
                  <Dropdown.Item eventKey="Mr.">Mr.</Dropdown.Item>
                  <Dropdown.Item eventKey="Ms.">Ms.</Dropdown.Item>
                  <Dropdown.Item eventKey="Mrs.">Mrs.</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="col-md-4">
              <label className="form-label">{first_name}</label>
              <span className="required">*</span>
              <input
                type="text"
                className="form-control"
                value={employeeData.candidateName}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    candidateName: e.target.value.replace(/^\s+/, ""),
                  })
                }
                required
              />
              <p className="error">{errors.candidateName}</p>
            </div>
            <div className="col-md-4">
              <label className="form-label">{middle_name}</label>
              <input
                type="text"
                className="form-control"
                value={employeeData.middleName}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    middleName: e.target.value.replace(/^\s+/, ""),
                  })
                }
              />
              <p className="error">{errors.middleName}</p>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-4">
              <label className="form-label">{last_name}</label>
              <span className="required">*</span>
              <input
                type="text"
                className="form-control"
                value={employeeData.lastname}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    lastname: e.target.value.replace(/^\s+/, ""),
                  })
                }
              />
              <p className="error">{errors.lastname}</p>
            </div>
            <div className="col-md-4">
              <label className="form-label">{date_of_birth}</label>
              <span className="required">*</span>
              <input
                type="date"
                max={moment().subtract(21, "year").format("YYYY-MM-DD")}
                value={employeeData.dateOfBirth}
                className="form-control"
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    dateOfBirth: e.target.value.replace(/^\s+/, ""),
                  })
                }
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Gender</label>
              <select
                className="form-control"
                value={employeeData.gender}
                onChange={(e) =>
                  setEmployeeData({ ...employeeData, gender: e.target.value })
                }
              >
                <option value="">Select</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>

          </div>

          <div className="row mt-3">
            <div className="col-md-4">
              <label className="form-label">{personal_email_iD}</label>
              <input
                type="email"
                className="form-control"
                value={employeeData.personalMail ?? ""}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    personalMail: e.target.value?.toLocaleLowerCase(),
                  })
                }
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">{e_code}</label>
              <span className="required">*</span>
              <input
                type="text"
                maxLength={9}
                className="form-control"
                value={employeeData.employeeId}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    employeeId: e.target.value.replace(/^\s+/, ""),
                  })
                }
                disabled={disable}
              />
              <p className="error">{errors.employeeId}</p>
            </div>
            <div className="col-md-4">
              <label className="form-label">{official_email}</label>
              <span className="required">*</span>
              <input
                type="email"
                className="form-control"
                value={employeeData.emailId}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    emailId: e.target.value?.toLocaleLowerCase(),
                  })
                }
                disabled={disable}
              />
              <p className="error">{errors.emailId}</p>
            </div>
            <div className="col-md-4 mt-3">
              <label className="form-label">{mobile_number}</label>
              <span className="required">*</span>

              <input
                type="text"
                maxLength={15}
                className="form-control"
                value={employeeData.mobileNumber}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    mobileNumber: e.target.value.replace(/^\s+/, ""),
                  })
                }
              />

              <p className="error">{errors.mobileNumber}</p>
            </div>

            <div className="col-md-4">
              <label className="form-label">{employee_designation}<span className="required">*</span></label>
              {isAddingDesignation ? (
                <InputGroup className="mb-3">
                  <input type="text" className="form-control" placeholder="Enter new designation" value={newDesignationName} onChange={(e) => setNewDesignationName(e.target.value)} autoFocus />
                  <BSButton variant="primary" onClick={handleAddNewDesignation} disabled={isSubmittingDesignation} style={{ zIndex: 0 }}>
                    {isSubmittingDesignation ? <Spinner size="sm" animation="border" /> : <BsCheckLg />}
                  </BSButton>
                  <BSButton variant="outline-secondary" onClick={() => setIsAddingDesignation(false)} style={{ zIndex: 0 }}>
                    <BsXLg />
                  </BSButton>
                </InputGroup>
              ) : (
                <Select
                  className="dropdown-select"
                  isSearchable={true}
                  placeholder="Select..."
                  value={employeeData.designation ? { value: employeeData.designationRef || employeeData.designation, label: employeeData.designation } : null}
                  options={[
                    ...(isHrAdmin ? [{ value: '__ADD__', label: '+ Add New Designation' }] : []),
                    ...designationOptions.map((d: any) => ({ value: d._id, label: d.title }))
                  ]}
                  onChange={(selected: any) => {
                    if (!selected) return;
                    if (selected.value === '__ADD__') { setIsAddingDesignation(true); return; }
                    setEmployeeData({
                      ...employeeData,
                      designation: selected.label,
                      designationRef: selected.value,
                    });
                    setErrors((errorObj: any) => ({ ...errorObj, designation: "" }));
                  }}
                  formatOptionLabel={(opt: any) => {
                    if (opt.value === '__ADD__') return <span style={{ color: '#0d6efd', fontWeight: 'bold' }}>{opt.label}</span>;
                    return <span>{opt.label}</span>;
                  }}
                  styles={{
                    control: (base: any) => ({
                      ...base,
                      minHeight: '38px',
                      height: '38px',
                      borderColor: errors.designation ? '#dc3545' : base.borderColor,
                    }),
                    valueContainer: (base: any) => ({ ...base, height: '38px', padding: '0 8px' }),
                    input: (base: any) => ({ ...base, margin: '0px', padding: '0px' }),
                    indicatorsContainer: (base: any) => ({ ...base, height: '38px' }),
                  }}
                />
              )}
              <p className="error">{errors.designation}</p>
            </div>

            <div className="col-md-4 mt-3">
              <label className="form-label">{date_of_joining}</label>
              <span className="required">*</span>
              <input
                type="date"
                max={moment().format("YYYY-MM-DD")}
                className="form-control"
                value={employeeData.dateOfJoining}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    dateOfJoining: e.target.value.replace(/^\s+/, ""),
                  })
                }
              />
            </div>
            <div className="col-md-4 mt-3">
              <label className="form-label">{clientNameLabel}<span className="required">*</span></label>
              {isAddingClient ? (
                <InputGroup className="mb-3">
                  <input type="text" className="form-control" value={newClientName} onChange={(e) => setNewClientName(e.target.value)} autoFocus />
                  {/* USE BSButton HERE */}
                  <BSButton variant="primary" onClick={handleAddNewClient} disabled={isSubmittingClient} style={{ zIndex: 0 }}>
                    {isSubmittingClient ? <Spinner size="sm" animation="border" /> : <BsCheckLg />}
                  </BSButton>
                  <BSButton variant="outline-secondary" onClick={() => setIsAddingClient(false)} style={{ zIndex: 0 }}>
                    <BsXLg />
                  </BSButton>
                </InputGroup>
              ) : (
                <Select
                  className="dropdown-select"
                  isSearchable={true}
                  placeholder="Select..."
                  value={employeeData.clientName ? { value: employeeData.clientRef, label: employeeData.clientName } : null}
                  options={clientOptions.map((c: any) => ({ value: c._id, label: c.clientName }))}
                  onChange={(selected: any) => {
                    if (!selected) return;
                    setEmployeeData({
                      ...employeeData,
                      clientName: selected.label,
                      clientRef: selected.value
                    });
                  }}
                  styles={{
                    control: (base: any) => ({
                      ...base,
                      borderColor: errors.clientName ? '#dc3545' : base.borderColor,
                      minHeight: '38px',
                    })
                  }}
                />
              )}
              <p className="error">{errors.clientName}</p>
            </div>
            <div className="col-md-4 mt-3">
              <label className="form-label">{reporting_manager_name}</label>
              <span className="required">*</span>
              <Select
                className="dropdown-select"
                placeholder={employeeData.reportingManagerName}
                options={managerOptions}
                isSearchable={true}
                onChange={handleReportingManager}
              />
            </div>
            <div className="col-md-4 mt-3">
              <label className="form-label">BU Head</label>
              <span className="required">*</span>
              <div style={{ height: "1rem" }}>
                <Select
                  className="dropdown-select"
                  // Try to find the object by ID first
                  value={managerOptions.find((opt: any) => opt.value === employeeData.buHeadRef) || null}
                  options={managerOptions}
                  isSearchable={true}
                  onChange={handleBuHeadChange}
                  isClearable={true}
                  placeholder={employeeData.buHead || "Select BU Head..."}
                />
              </div>
            <p className="error">{errors.buHead}</p>
            </div>

            <div className="col-md-4 mt-3">
              <label className="form-label">HR Business Partner (HRBP)</label>
              {/* <span className="required">*</span> Uncomment if mandatory */}
              <div style={{ height: "1rem" }}>
                <Select
                  className="dropdown-select"
                  value={managerOptions.find((opt: any) => opt.value === employeeData.hrbpRef) || null}
                  options={managerOptions}
                  isSearchable={true}
                  onChange={handleHrbpChange}
                  isClearable={true}
                  placeholder="Select HRBP..."
                />
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <label htmlFor="inputName4" className="form-label">
                {status}
              </label>

              <Dropdown
                onSelect={(eventKey: any) => {
                  if (eventKey == "Active") {
                    setStatusDetails((obj) => ({
                      ...obj,
                      status: eventKey,
                      recordStatus: "Draft",
                      lastWorkingDate: "",
                      reason: "",
                      reasonForResignation: "",
                    }));
                  } else if (eventKey == "New") {
                    setStatusDetails((obj) => ({
                      ...obj,
                      status: eventKey,
                      recordStatus: "Re-Sent",
                      lastWorkingDate: "",
                      reason: "",
                      reasonForResignation: "",
                    }));
                  } else {
                    setStatusDetails((obj) => ({
                      ...obj,
                      status: eventKey,
                      recordStatus: "",
                    }));
                  }
                }}
              >
                <Dropdown.Toggle variant="light" className="form-control">
                  {statusDetails.status}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    eventKey={active_label}
                    hidden={!employeeHrManager}
                  >
                    {active_label}
                  </Dropdown.Item>
                  <Dropdown.Item eventKey={inactive_label}>
                    {inactive_label}
                  </Dropdown.Item>
                  <Dropdown.Item eventKey={new_label}>
                    {new_label}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            {recordStatus === "Approved" && statusDetails.status !== "Inactive" ? (
              <div className="col-md-4 mt-3">
                <label htmlFor="inputName4" className="form-label">{record_status}</label>
                <span className="required">*</span>
                <input
                  type="text"
                  className="form-control"
                  value="Approved"
                  disabled
                />
              </div>
            ) : // THE FIX: If user selects "Active", show a dropdown with Draft/Approved
              statusDetails.status === "Active" ? (
                <div className="col-md-4 mt-3">
                  <label htmlFor="inputName4" className="form-label">{record_status}</label>
                  <span className="required">*</span>
                  <Dropdown
                    onSelect={(eventKey: any) =>
                      setStatusDetails({ ...statusDetails, recordStatus: eventKey })
                    }
                  >
                    <Dropdown.Toggle variant="light" className="form-control">
                      {statusDetails.recordStatus}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item eventKey="Draft">Draft</Dropdown.Item>
                      <Dropdown.Item eventKey="Approved">Approved</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              ) :
                statusDetails.status === "Inactive" ? (
                  <div className="col-md-4 mt-3">
                    <label htmlFor="inputName4" className="form-label">{record_status}</label>
                    <span className="required">*</span>
                    <Dropdown
                      onSelect={(eventKey: any) =>
                        setStatusDetails({ ...statusDetails, recordStatus: eventKey })
                      }
                    >
                      <Dropdown.Toggle variant="light" className="form-control">
                        {statusDetails.recordStatus}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item eventKey={absconded_label}>{absconded_label}</Dropdown.Item>
                        <Dropdown.Item eventKey={resigned_label}>{resigned_label}</Dropdown.Item>
                        <Dropdown.Item eventKey="Terminated">Terminated</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                ) :
                  statusDetails.status === "New" ? (
                    <div className="col-md-4 mt-3">
                      <label htmlFor="inputName4" className="form-label">{record_status}</label>
                      <span className="required">*</span>
                      <input
                        type="text"
                        className="form-control"
                        value={statusDetails.recordStatus}
                        disabled
                      />
                    </div>
                  ) : null}
            {statusDetails.status == "Inactive" && (
              <div className="col-md-4 mt-3">
                <label className="form-label">{last_working_date}</label>
                <span className="required">*</span>
                <input
                  type="date"
                  max={new Date().toISOString().split("T")[0]}
                  className="form-control"
                  value={statusDetails.lastWorkingDate}
                  onChange={(e) =>
                    setStatusDetails({
                      ...statusDetails,
                      lastWorkingDate: e.target.value,
                    })
                  }
                />
              </div>
            )}
            {statusDetails.recordStatus == "Re-Sent" && (
              <div className="col-md-4 mt-3">
                <label className="form-label">{Reason}</label>
                <input
                  type="text"
                  className="form-control"
                  value={statusDetails.reason}
                  onChange={(e) =>
                    setStatusDetails({
                      ...statusDetails,
                      reason: e.target.value,
                    })
                  }
                />
              </div>
            )}
            {statusDetails.recordStatus == "Re-Sent" && (
              <div className="col-md-4 mt-3">
                <label className="form-label">Resent Date</label>
                <input
                  disabled={true}
                  className="form-control"
                  value={
                    statusDetails.resentDate
                      ? timeDateFormat(statusDetails.resentDate)
                      : "--/--/----"
                  }
                />
              </div>
            )}
            {statusDetails.recordStatus == "Resigned" && (
              <div className="col-md-4 mt-3">
                <label className="form-label">{ReasonForResignation}</label>
                <input
                  type="text"
                  className="form-control"
                  value={statusDetails.reasonForResignation}
                  onChange={(e) =>
                    setStatusDetails({
                      ...statusDetails,
                      reasonForResignation: e.target.value,
                    })
                  }
                />
              </div>
            )}
            <div className="col-md-4 mt-3">
              <label className="form-label">Business Unit</label>
              <span className="required">*</span>
              <input
                type="text"
                className="form-control"
                value={employeeData.businessUnit}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    businessUnit: e.target.value.replace(/^\s+/, ""),
                  })
                }
              />
              <p className="error">{errors.businessUnit}</p>
            </div>
            <div className="col-md-4 mt-3">
              <label className="form-label">{departmentLabel}<span className="required">*</span></label>
              {isAddingDept ? (
                <InputGroup className="mb-3">
                  <input type="text" className="form-control" value={newDeptName} onChange={(e) => setNewDeptName(e.target.value)} autoFocus />
                  {/* USE BSButton HERE */}
                  <BSButton variant="primary" onClick={handleAddNewDept} disabled={isSubmittingDept} style={{ zIndex: 0 }}>
                    {isSubmittingDept ? <Spinner size="sm" animation="border" /> : <BsCheckLg />}
                  </BSButton>
                  <BSButton variant="outline-secondary" onClick={() => setIsAddingDept(false)} style={{ zIndex: 0 }}>
                    <BsXLg />
                  </BSButton>
                </InputGroup>
              ) : (
                <Select
                  className="dropdown-select"
                  isSearchable={true}
                  placeholder="Select..."
                  value={employeeData.department ? { value: employeeData.departmentRef, label: employeeData.department } : null}
                  options={[
                    ...(isHrAdmin ? [
                      { value: '__ADD__', label: '+ Add New Department' },
                      { value: '__MANAGE__', label: '⚙ Manage Departments' },
                    ] : []),
                    ...deptOptions.map((d: any) => ({ value: d._id, label: d.departmentName }))
                  ]}
                  onChange={(selected: any) => {
                    if (!selected) return;
                    if (selected.value === '__ADD__') { setIsAddingDept(true); return; }
                    if (selected.value === '__MANAGE__') { setShowDeptManager(true); return; }
                    setEmployeeData({
                      ...employeeData,
                      department: selected.label,
                      departmentRef: selected.value,
                      subDepartment: "",
                      subDepartmentRef: ""
                    });
                    setSubDeptOptions([]);
                  }}
                  formatOptionLabel={(opt: any) => {
                    if (opt.value === '__ADD__') return <span style={{ color: '#0d6efd', fontWeight: 'bold' }}>{opt.label}</span>;
                    if (opt.value === '__MANAGE__') return <span style={{ color: '#6c757d' }}>{opt.label}</span>;
                    return <span>{opt.label}</span>;
                  }}
                  styles={{
                    control: (base: any) => ({
                      ...base,
                      borderColor: errors.department ? '#dc3545' : base.borderColor,
                      minHeight: '38px',
                    })
                  }}
                />
              )}
              <p className="error">{errors.department}</p>
            </div>

            <div className="col-md-4 mt-3">
              <label className="form-label">Sub Department<span className="required">*</span></label>
              {isAddingSubDept ? (
                <InputGroup className="mb-3">
                  <input type="text" className="form-control" value={newSubDeptName} onChange={(e) => setNewSubDeptName(e.target.value)} autoFocus />
                  <BSButton variant="primary" onClick={handleAddNewSubDept} disabled={isSubmittingSubDept} style={{ zIndex: 0 }}>
                    {isSubmittingSubDept ? <Spinner size="sm" animation="border" /> : <BsCheckLg />}
                  </BSButton>
                  <BSButton variant="outline-secondary" onClick={() => setIsAddingSubDept(false)} style={{ zIndex: 0 }}>
                    <BsXLg />
                  </BSButton>
                </InputGroup>
              ) : (
                <Select
                  className="dropdown-select"
                  isSearchable={true}
                  placeholder="Select..."
                  isDisabled={!employeeData.department}
                  value={employeeData.subDepartment ? { value: employeeData.subDepartmentRef, label: employeeData.subDepartment } : null}
                  options={[
                    ...(isHrAdmin ? [
                      { value: '__ADD__', label: '+ Add New Sub-Dept' },
                      { value: '__MANAGE__', label: '⚙ Manage Sub-Depts' },
                    ] : []),
                    ...subDeptOptions.map((d: any) => ({ value: d._id, label: d.subDepartmentName }))
                  ]}
                  onChange={(selected: any) => {
                    if (!selected) return;
                    if (selected.value === '__ADD__') { setIsAddingSubDept(true); return; }
                    if (selected.value === '__MANAGE__') { setShowSubDeptManager(true); return; }
                    setEmployeeData({
                      ...employeeData,
                      subDepartment: selected.label,
                      subDepartmentRef: selected.value
                    });
                  }}
                  formatOptionLabel={(opt: any) => {
                    if (opt.value === '__ADD__') return <span style={{ color: '#0d6efd', fontWeight: 'bold' }}>{opt.label}</span>;
                    if (opt.value === '__MANAGE__') return <span style={{ color: '#6c757d' }}>{opt.label}</span>;
                    return <span>{opt.label}</span>;
                  }}
                  styles={{
                    control: (base: any) => ({
                      ...base,
                      borderColor: errors.subDepartment ? '#dc3545' : base.borderColor,
                      minHeight: '38px',
                    })
                  }}
                />
              )}
              <p className="error">{errors.subDepartment}</p>
            </div>
            <div className="col-md-4 mt-3">
              <label className="form-label">Finance Code</label>
              <span className="required">*</span>
              <input
                type="text"
                className="form-control"
                value={employeeData.financeCode}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    financeCode: e.target.value.replace(/^\s+/, ""),
                  })
                }
              />
              <p className="error">{errors.financeCode}</p>
            </div>
            <div className="col-md-4 mt-3">
              <label className="form-label">Project Classification</label>
              <span className="required">*</span>
              <input
                type="text"
                className="form-control"
                value={employeeData.projectClassification}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    projectClassification: e.target.value.replace(/^\s+/, ""),
                  })
                }
              />
              <p className="error">{errors.projectClassification}</p>
            </div>
               <div className="col-md-4 mt-3">
              <label className="form-label">Mode of Work</label>
              <span className="required">*</span>
              <input
                type="text"
                className="form-control"
                value={employeeData.modeofWork}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    modeofWork: e.target.value.replace(/^\s+/, ""),
                  })
                }
              />
              <p className="error">{errors.modeofWork}</p>
            </div>
            <div className="col-md-4 mt-3">
              <label className="form-label">Project Type</label>
              <span className="required">*</span>
              <input
                type="text"
                className="form-control"
                value={employeeData.projectType}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    projectType: e.target.value.replace(/^\s+/, ""),
                  })
                }
              />
              <p className="error">{errors.projectType}</p>
            </div>

            <div className="col-md-4 mt-3">
              <label className="form-label">Location</label>
              <span className="required">*</span>
              <input
                type="text"
                className="form-control"
                value={employeeData.location}
                onChange={(e) =>
                  setEmployeeData({
                    ...employeeData,
                    location: e.target.value.replace(/^\s+/, ""),
                  })
                }
              />
              <p className="error">{errors.location}</p>
            </div>
          </div>
          <div className="d-flex justify-content-between mt-5">
            <div className="modal-btn-wrapper">
              <div>
                <button
                  className="btn cancel-btn buttonsize"
                  onClick={hideEditModal}
                >
                  {cancel}
                </button>
              </div>
              <div>
                <button
                  className={
                    btnDisable
                      ? "btn add-submit-button buttonsize"
                      : "btn add-submit-button btn-disabled buttonsize"
                  }
                  onClick={handleSimpleSubmit}
                  disabled={isApproving}
                  style={isApproving ? { opacity: 0.7, cursor: "not-allowed", display: "flex", alignItems: "center", gap: 6 } : {}}
                >
                  {isApproving ? <><Spinner size="sm" animation="border" /> Submitting...</> : submit}
                </button>
              </div>
            </div>
            <div>
              {statusDetails.status !== "Inactive" && recordStatus !== "Approved" && employeeDbChecker && (
                <div className="heading-button-wrapper">
                  <Button
                    title="Send Email"
                    onClick={() =>
                      setShowConfirmModal(true)}
                    className="add-employee-btn"
                  ></Button>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <SendEmail
          apiCallCompleted={apiCallCompleted}
          employeeData={employeeData}
          hideEditModal={hideEditModal}
          setnextScreen={setnextScreen}
        />
      )}
      <DepartmentManagerModal
        show={showDeptManager}
        onHide={() => setShowDeptManager(false)}
        title="Departments"
        data={deptOptions.map(d => ({ _id: d._id, name: d.departmentName }))}
        type="DEPARTMENT"
        refreshData={() => dispatch(actions.getAllDepartmentsAction((res: any) => setDeptOptions(res.data)))}
      />
      <DepartmentManagerModal
        show={showSubDeptManager}
        onHide={() => setShowSubDeptManager(false)}
        title="Sub-Departments"
        data={subDeptOptions.map(d => ({ _id: d._id, name: d.subDepartmentName }))}
        type="SUB_DEPARTMENT"
        refreshData={() => {
          const parent = deptOptions.find(d => d.departmentName === employeeData.department);
          if (parent) dispatch(actions.getSubDepartmentsByParentAction(parent._id, (res: any) => setSubDeptOptions(res.data)));
        }}
        onReassignSuccess={(oldId: string, newTarget: any) => {
          console.log("REASSIGN SUCCESS EVENT:", newTarget);

          setJustReassigned(true);
          const fullLabel = newTarget.label;
          const matches = fullLabel.match(/^(.*) \((.*)\)$/);

          let subName = fullLabel;
          let deptName = "";

          if (matches && matches.length >= 3) {
            subName = matches[1];
            deptName = matches[2];
          }

          //   console.log(`Moving to: Sub=[${subName}] Dept=[${deptName}]`);

          const newDeptObj = deptOptions.find(d => d.departmentName === deptName);
          const newDeptId = newDeptObj ? newDeptObj._id : "";

          setEmployeeData(prev => ({
            ...prev,
            // Update Sub-Dept
            subDepartment: subName,
            subDepartmentRef: newTarget.value,
            department: deptName || prev.department,
            departmentRef: newDeptId || prev.departmentRef
          }));
          if (newDeptId) {
            dispatch(actions.getSubDepartmentsByParentAction(newDeptId, (res: any) => {
              if (res?.data) setSubDeptOptions(res.data);
            }));
          }
          dispatch(actions.getEmployeeDataAction());
        }}
      />
      <ClientManagerModal
        show={showClientManager}
        onHide={() => setShowClientManager(false)}
        data={clientOptions}
        refreshData={() => dispatch(actions.getClientNameAction())}
        onReassignSuccess={(oldId: string, newTarget: any) => {
          console.log("CLIENT REASSIGN EVENT:", newTarget);

          setJustReassigned(true);

          // 1. Find the Name of the Client being deleted (from the current list)
          const oldClientObj = clientOptions.find(c => c._id === oldId);
          const oldClientName = oldClientObj ? oldClientObj.clientName : "";

          // 2. SMART CHECK: Match by ID -OR- Match by Name
          const isMatch =
            employeeData.clientRef === oldId ||
            (employeeData.clientName && employeeData.clientName === oldClientName);

          if (isMatch) {
            console.log("Updating Client Selection to:", newTarget.label);

            setEmployeeData(prev => ({
              ...prev,
              clientName: newTarget.label, // The New Name
              clientRef: newTarget.value   
            }));
          }

          dispatch(actions.getClientNameAction());
        }}
      />
    </>
  );
};

export default EditEmployee;
